import { ref } from 'vue';

export const useLoading = () => {
  const loading = ref<boolean>(false);

  const setLoading = (v: boolean) => (loading.value = v);

  return { loading, setLoading };
};
